module.exports = __webpack_public_path__ + "static/img/app_bg2.aa6f2ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_bg2.jpg
// module id = uMK3
// module chunks = 0